var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-5 filter-column"},[_c('page-filter-city',{attrs:{"page-filter-type":'cinema',"id-prefix":_vm.idPrefix,"icon":'fas fa-map-pin',"plural":'Steden',"input-name":'city',"items":[]}})],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b328707","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/cinemas/CinemaFilters.vue
// module id = 8LqM
// module chunks = 0